import { graphql } from '@teachino/shared-infrastructure';

export const featureFragment = graphql(`
  fragment Feature on Feature {
    key
  }
`);
